module.exports = __webpack_public_path__ + "img/3_160.5ef2ddce.png";